import Vue from 'vue';
import Router from 'vue-router';

import ErrIndex from '../page/error/Index';

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

export function createRouter() {
  return new Router({
    mode: 'history',
    fallback: false,
    routes: [
      // 首页
      {
        path: '/home',
        name: 'home',
        meta: {
          mtype: 'home',
        },
        alias: ['/', '/index.html'],
        component: () => import(/* webpackChunkName: "home" */ '../page/home/Index.vue'),
      },
      // 搜索结果页
      {
        path: '/v',
        name: 'v',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      {
        path: '/search',
        name: 'search',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      {
        path: '/vertical/:key',
        name: 'vertical',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      // 热门搜索页
      {
        path: '/hotsugg',
        name: 'hotsugg',
        meta: {
          mtype: 'hotsugg',
        },
        component: () => import(/* webpackChunkName: "hotsugg" */ '../page/hotsugg/Index.vue'),
      },
      // 播单列表
      {
        path: '/playlist/:key',
        name: 'playlist',
        meta: {
          mtype: 'playlist',
        },
        component: () => import(/* webpackChunkName: "playlist" */ '../page/playlist/Index.vue'),
      },
      // 寻址页
      {
        path: '/qlist/:key',
        name: 'qlist',
        meta: {
          mtype: 'qlist',
        },
        component: () => import(/* webpackChunkName: "qlist" */ '../page/qlist/Index.vue'),
      },
      // 错误页
      {
        path: '/error',
        name: 'error',
        meta: {
          mtype: 'error',
        },
        component: () => import(/* webpackChunkName: "error" */ '../page/error/Index.vue'),
      },
      // 通用视频页
      {
        path: '/savideo',
        name: 'savideo',
        meta: {
          mtype: 'savideo',
        },
        component: () => import(/* webpackChunkName: "savideo" */ '../page/savideo/Index.vue'),
      },
      {
        path: '*',
        component: ErrIndex,
      },
    ],
  });
}
